// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: 'https://websvc.nantel.org/NantelRest/',
  // baseURL: 'http://localhost:63215/',
  csodURL:
    'https://nantel.csod.com/LMS/catalog/Welcome.aspx?tab_page_id=-67&tab_id=-1',
  courseCatalogURL:
    'https://contentprd.nantel.org/production/CourseCatalog/Course_Catalog.pdf',
  recaptcha: {
    siteKey: '6LcHPm0UAAAAAGDcl1d2AdRGJ6oWfqMRGqwsbsiH',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
